import axiosClient from "../axios-client";
import {toastMessage} from "../toaster/toaster";
import {changeLoaderStatus} from "./loaderAction";

export const allAgentsBankDetailsGet = async (dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .get("/agent/kyc-verification")
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            toastMessage("Partner bank details not found", "error");
            return error;
        }).finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        });
};


export const updateAgentBankDetailStatus = async (dispatch, id, status) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .put(`/agent/kyc-verification/${id}`, {status: status})
        .then((res) => {
            toastMessage("Details updated successfully", "success");
            return res?.data;
        })
        .catch((error) => {
            toastMessage("Details not updated", "error");
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};

export const getIndividualAgentBankDetails = async (id) => {
    return axiosClient
        .get(`/agent/kyc-verification/${id}`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            toastMessage("Partner bank detail not found", "error");
            return error;
        })
}
